module.exports = __webpack_public_path__ + "static/media/fyffes.031d7c00.png";